/**
 * @file 表格表头配置文件
 * @description 包含创建、编辑和管理表的表头列表
 */

/**
 * 表格表头配置文件,定义表头属性和列
 * @typeof tableList
 * @property {string} label - 表头标签
 * @property {string} prop - 对应数据字段
 * @property {string} type - 输入框类型
 * - input: 输入框
 * - select: 下拉框
 * - switch: 开关
 * - range: 范围
 * - group: 分组下拉
 * - changeable: 可根据条件改变
 * @property {string} width - 列宽度
 * @property {boolean} isfixed - 是否合并列
 * @property {boolean} disabled - 是否禁用
 * @property {string} disabledKey - 禁用条件字段
 * @property {Array} filterable - 是否可过滤
 * @property {Array} remote - 是否远程加载
 * @property {Array} options - 下拉选项列表
 */

/**
 * 选项列表
 * @typedef {Object} optionsList
 * @property {string} label - 选项标签
 * @property {string} value - 选项值
 */

// 协议创建表格-表头
export const protocolTableList = [
  // {
  //   label: '起始地址（0x）',
  //   prop: 'startAddress',
  //   type: 'input',
  //   isfixed: true,
  //   required: true,
  //   width: 170
  // },
  {
    label: '寄存器个数',
    prop: 'dataLength',
    type: 'input',
    required: true,
    width: 130
  },
  {
    label: '名称',
    prop: 'dataName',
    type: 'input',
    required: true,
    width: 180
  },
  {
    label: '数据库表',
    prop: 'databaseFiled',
    type: 'input',
    width: 180
  },
  {
    label: '数据库字段',
    prop: 'databaseColumn',
    type: 'input',
    width: 180
  },
  {
    label: '数据类型',
    prop: 'dataType',
    type: 'select',
    options: [],
    required: true,
    width: 130
  },
  {
    label: '需要映射',
    prop: 'needMapping',
    type: 'switch',
    width: 90
  },
  {
    label: '映射类别',
    prop: 'mappingType',
    type: 'select',
    disabled: true,
    disabledKey: 'needMapping',
    options: [],
    width: 130
  },
  {
    label: '映射表',
    prop: 'mappingName',
    type: 'group',
    disabled: true,
    disabledKey: 'needMapping',
    filterable: true,
    remote: true,
    width: 150,
    options: [
      {
        label: '值映射',
        options: []
      },
      {
        label: 'bit位映射',
        options: []
      }
    ]
  },
  {
    label: '单位',
    prop: 'unit',
    type: 'input',
    width: 110
  },
  {
    label: '小数点',
    prop: 'decimal',
    type: 'input',
    width: 150
  },
  // {
  //   label: '极值',
  //   prop: 'range',
  //   type: 'range',
  //   width: 150
  // }
]

// 协议管理表格-表头
export const protocolManageList = [
  {
    label: '协议名称',
    prop: 'protocolName',
    type: 'text',
    searchShow: true,
    tableShow: true
  },
  {
    label: '协议类型',
    prop: 'protocolType',
    type: 'select',
    options: [],
    searchShow: true,
    tableShow: true
  },
  {
    label: '产品类型',
    prop: 'deviceType',
    type: 'select',
    options: [],
    searchShow: true,
    tableShow: true
  },
  {
    label: '协议版本',
    prop: 'protocolVersion',
    type: 'text',
    searchShow: true,
    tableShow: true
  },
  {
    label: '更新日期',
    prop: 'updateTime',
    type: 'daterange',
    sortable: true,
    searchShow: true,
    tableShow: true
  }
]

// 映射表管理-表头
export const mappingTableManageList = [
  {
    label: '映射表名称',
    prop: 'mappingName',
    type: 'text',
    searchShow: true,
    tableShow: true
  },
  {
    label: '协议名称',
    prop: 'protocolName',
    type: 'text',
    searchShow: true,
    tableShow: true
  },
  {
    label: '映射类别',
    prop: 'mappingType',
    type: 'select',
    options: [],
    searchShow: true,
    tableShow: true
  },
  {
    label: '更新日期',
    prop: 'updateTime',
    type: 'daterange',
    sortable: true,
    searchShow: true,
    tableShow: false
  }
]

// 字典管理-表头
export const dictionaryManageList = [
  {
    label: '字典名称',
    prop: 'dictName',
    type: 'text',
    searchShow: true,
    tableShow: true
  },
  {
    label: '字典编码',
    prop: 'dictCode',
    type: 'text',
    searchShow: true,
    tableShow: true
  },
  {
    label: '状态',
    prop: 'status',
    type: 'select',
    searchShow: true,
    tableShow: true,
    options:[]
  },
  {
    label: '字典描述',
    prop: 'description',
    type: 'text',
    searchShow: false,
    tableShow: true
  },
  {
    label: '更新日期',
    prop: 'updateTime',
    type: 'daterange',
    sortable: true,
    searchShow: true,
    tableShow: true
  }
]

// 字典项管理-表头
export const dictionaryChildrenManageList = [
  {
    label: '字典项名称',
    prop: 'itemName',
    type: 'text',
    searchShow: true,
    tableShow: true
  },
  {
    label: '字典项编码',
    prop: 'itemCode',
    type: 'text',
    searchShow: false,
    tableShow: true
  },
  {
    label: '字典项值',
    prop: 'itemValue',
    type: 'text',
    sortable: true,
    searchShow: true,
    tableShow: true
  },
  {
    label: '状态',
    prop: 'status',
    type: 'select',
    options: [],
    searchShow: true,
    tableShow: true
  },
  {
    label: '字典项描述',
    prop: 'description',
    type: 'text',
    searchShow: false,
    tableShow: true
  },
  {
    label: '更新日期',
    prop: 'updateTime',
    type: 'daterange',
    sortable: true,
    searchShow: true,
    tableShow: true
  }
]
